// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\locations.$location.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\locations.$location.tsx");
  import.meta.hot.lastModified = "1760465839265.257";
}
// REMIX HMR END

import { useLoaderData } from "@remix-run/react";
import { WelcomeSection, LocationInfo, StudiosSection, EventsSection, PlanYourVisitSection } from "~/components/pages/locations";
import { MembershipSection } from "~/components/shared/MembershipSection";
import { PeopleSection } from "~/components/shared/PeopleSection";
//import { locationsConfig, type LocationType } from "~/config/locations";
import en from "~/config/lang/en.json";
import sp from "~/config/lang/sp.json";
const translations = {
  en,
  sp
};
export async function loader({
  params
}) {
  // get location from params
  const location = params.location;

  // get language from location storage
  const lang = "en"; //localStorage.getItem("lang") || "en";

  // get translations based on language
  const languageData = translations[lang];
  const locationData = languageData[location];
  if (!locationData) {
    throw new Response("Location Not Found", {
      status: 404
    });
  }
  const apiRes = await fetch(`https://nomadicstudios.net:444/api/locations/${location}`);
  const apiData = await apiRes.json();
  locationData.welcome.backgroundImage = apiData.data.banner_picture;
  return Response.json({
    location,
    locationData,
    apiData: apiData
  });
}
export const meta = ({
  data
}) => {
  if (!data) {
    return [{
      title: "Location Not Found | Nomadics"
    }, {
      name: "description",
      content: "The requested location was not found."
    }];
  }
  return [{
    title: data.locationData.meta.title
  }, {
    name: "description",
    content: data.locationData.meta.description
  }];
};
export default function LocationPage() {
  _s();
  const {
    locationData,
    apiData
  } = useLoaderData();
  return <div>
      <WelcomeSection data={locationData.welcome} />
      <LocationInfo data={locationData.info} />
      <StudiosSection data={apiData.data} />
      {apiData.data.resources?.length > 0 && <PeopleSection title={locationData.people.title} peopleData={apiData.data.resources} filterOptions={apiData.data.filters} />}
      {apiData.data.events?.length > 0 && <EventsSection title={locationData.events.sectionTitle} data={apiData.data.events} />}
      <PlanYourVisitSection title={locationData.planVisit.title} address={apiData.data.address} hours={apiData.data.opening_hours} phone={apiData.data.phone} email={apiData.data.email} additionalInfo={apiData.data.additional_info} location={apiData.data.location} />
      <MembershipSection theme="black" />
    </div>;
}
_s(LocationPage, "9kkiYmM0w4G4Q/qu00qTdj5Py9g=", false, function () {
  return [useLoaderData];
});
_c = LocationPage;
var _c;
$RefreshReg$(_c, "LocationPage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;